package com.tovtalk.utils.strings

import kotlinx.serialization.json.Json
import kotlinx.serialization.json.JsonPrimitive
import kotlinx.serialization.json.jsonObject

/**
 * טוען תרגומים מקובצי JSON מובנים (shared/translations/en.json, he.json).
 * כל התרגומים נמצאים בקבצים המקומיים בלבד – אין שליפה מהשרת.
 *
 * ראה shared/translations/README.md
 */
object BundledFallbackTranslations {
    private val json = Json { ignoreUnknownKeys = true }

    private fun jsonStringToMap(jsonStr: String): Map<String, String> {
        val obj = json.parseToJsonElement(jsonStr).jsonObject
        return obj.entries.associate { entry ->
            entry.key to when (val v = entry.value) {
                is JsonPrimitive -> v.content
                else -> v.toString()
            }
        }
    }

    fun get(languageCode: String): Map<String, String> {
        val raw = readBundledTranslationsJson(
            if (languageCode == "he") "he" else "en"
        ) ?: return emptyMap()
        return runCatching { jsonStringToMap(raw) }.getOrElse { emptyMap() }
    }
}
